export default "* Et eller flere øjenbind eller tørklæde\n* Evt. Ask & Liv-planche med illustration af tjur og los \n";